import { SimpleGuard } from 'interfaces/guards'
import { getMixedAccountsActionCreator } from 'actions/linkageActions'

// ===========================================================================//
//                             LINKED PROVIDER ACCOUNTS                       //
// ===========================================================================//

export const linkedMixedAccountsGuard: SimpleGuard = {
  name: 'Linked Mixed Accounts',
  checker: (state) => {
    const { providerBalanceAccounts, manualBalanceAccounts, providerAccounts } = state.data.linkage
    return Boolean(providerBalanceAccounts && manualBalanceAccounts && providerAccounts)
  },
  loader: (dispatch) => dispatch(getMixedAccountsActionCreator.request({})),
}

// ===========================================================================//
//                             LINKED PROVIDER ACCOUNTS                       //
// ===========================================================================//

type LiveGuardOwnProps = {
  isOnboarding?: boolean
}

// pass component only when we got first response from live update
export const liveUpdateGuard2: SimpleGuard<LiveGuardOwnProps> = {
  name: 'Live Update',
  checker: (state, ownProps) =>
    ownProps.isOnboarding
      ? true
      : Boolean(state.data.linkage.liveUpdate),
  loader: () => {
    // do nothing, epic should request life update by itself
  },
}
